import { useQuery } from "@tanstack/react-query";
import { clientAPI } from "../../api/client";

async function fetchConstantData() {
  const searchOptions = {
    limit: 10000000,
    page: 1,
  };

  const searchOptionEmps = {
    limit: 10000000,
    page: 1,
    status: 0,
  };

  const searchQueryParams = new URLSearchParams(searchOptions).toString();
  const searchQueryParamEmps = new URLSearchParams(searchOptionEmps).toString();

  // Fetch constant data concurrently
  const [employee, saleArea, saleBlock, departmentData] = await Promise.all([
    clientAPI("get", `/employee?${searchQueryParamEmps}`),
    clientAPI("get", `/saleArea?${searchQueryParams}`),
    clientAPI("get", `/saleBlock?${searchQueryParams}`),
    clientAPI("get", `/department?${searchQueryParams}`),
  ]);

  // Index data by 'id' to improve lookup performance
  return {
    employee: employee?.items?.reduce(
      (acc, item) => ({
        ...acc,
        [item._id]: {
          fullName: item.fullName,
          code: item.code,
        },
      }),
      {}
    ),
    saleArea: saleArea?.items?.reduce(
      (acc, item) => ({ ...acc, [item._id]: item.name }),
      {}
    ),
    saleBlock: saleBlock?.items?.reduce(
      (acc, item) => ({ ...acc, [item._id]: item.name }),
      {}
    ),
    departmentByNumbers: departmentData?.items?.reduce(
      (acc, item) => ({ ...acc, [item.id]: item.name }),
      {}
    ),
  };
}

export function useCategories() {
  // Fetch constant data once
  const {
    data: constantData,
    isLoading,
    isFetching,
    refetch,
  } = useQuery({
    queryKey: ["getDeviceActivityLog"],
    queryFn: () => fetchConstantData(),
    refetchOnWindowFocus: false,
  });

  return {
    constantData,
    isLoading,
    isFetching,
    refetch,
  };
}
